import React from 'react';
import Header from 'layouts/HomeHeader';
import Main from './components';

const Pricing = () => {
  return (
    <>
      <Header />
      <Main />
    </>
  );
};
export default Pricing;
